<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">

            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-6 vincent_reservation_block ">
                    <!-- <h6>القرن مع إصدار رقائق</h6> -->
                    <h1 class="">كن دائما معنا</h1>
                    <img src="assets/imgs/separator_dark.png">
                    <p>لوحة التحكم و عرض الطلبات</p>
                    <p style="font-size: 10px;">  الرجاء وضع البريد الخاص و كلمة المرور الخاص بالفرع أو الرئيسي</p>
                    <div class="vincent_form_block ">
                        <form class="vincent_form" #f="ngForm" (ngSubmit)="login(f)">
                            <div class="row gutters">
                                <div class="col col-6">
                                    <input ngModel name="email" #email="ngModel" type="email" class="form_user-name" placeholder="البريد الألكتروني" required email style="text-align: center;">
                                    <p *ngIf="email.errors?.required && email.touched">الرجاء أدخال عنوان البريد الألكتروني</p>
                                    <p *ngIf="email.errors?.email && email.touched"> الرجاء أدخال بريد الأكتروني صحيح</p>
                                </div>
                                <div class="col col-6">
                                    <input ngModel name="password" #password="ngModel" type="password" class="form_user-name" placeholder="كلمة المرور" style="text-align: center;" required>
                                        <p *ngIf="password.errors?.required && password.touched">الرجاءأدخال المرور</p>
                                </div>
                            </div>
                            <input type="submit" id="submit" class="default-btn-one" value="دخول" [disabled]="f.invalid || submit == false" style=" background-color: initial; width: 65px;">
                            <p id="loading" *ngIf="loading == true">جاري التحميل</p>
                            <div class="alert alert-primary cus" role="alert" *ngIf="errorMessage !=='' ">
                                الرجاء التأكد من البيانات المدخلة
                                {{errorMessage}}
                             </div>
                        </form>
                    </div>
                </div>
                <div class="col col-6">
                    <div class="logo-side">
                        <a routerLink="/">
                            <img src="assets/imgs/logo.png">
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>